export const SET_AREA = "SET_AREA";
export const SET_WIDTH = "SET_WIDTH";
export const SET_LENGTH = "SET_LENGTH";
export const SET_VOLUME = "SET_VOLUME";
export const SET_APPLY_COMPRESSION = "SET_APPLY_COMPRESSION";
export const SET_DEPTH = "SET_DEPTH";
export const SHOW_MORE_PRODUCT_INFO_POPUP = 'SHOW_MORE_PRODUCT_INFO_POPUP';

export const setArea = (area) => ({
    type: SET_AREA,
    payload: {
        area
    }
});

export const setWidth = (width) => ({
    type: SET_WIDTH,
    payload: {
        width
    }
});

export const setLength = (length) => ({
    type: SET_LENGTH,
    payload: {
        length
    }
});

export const setVolume = (volume) => ({
    type: SET_VOLUME,
    payload: {
        volume
    }
});

export const setApplyCompression = (applyCompression) => ({
    type: SET_APPLY_COMPRESSION,
    payload: {
        applyCompression
    }
});

export const setDepth = (depth) => ({
    type: SET_DEPTH,
    payload: {
        depth
    }
});

export const showQuantityCalculatorMoreProductInfoPopUp = (productUrl) => ({
    type: SHOW_MORE_PRODUCT_INFO_POPUP,
    payload: {
        showQuantityCalculatorMoreProductInfoPopUp: true,
        productUrl
    }
})

export const hideQuantityCalculatorMoreProductInfoPopUp = () => ({
    type: SHOW_MORE_PRODUCT_INFO_POPUP,
    payload: {
        showQuantityCalculatorMoreProductInfoPopUp: false,
    }
});